// material-ui
import logoLight from 'assets/images/logo.svg';
import logoDark from 'assets/images/logo-white.svg';
import d1hubLogo from 'assets/images/d1hub-logo.png';
import { useSelector } from 'react-redux';
import { useTheme } from '@mui/material/styles';

/**
 * if you want to use image instead of <svg> uncomment following.
 *
 * import logoDark from 'assets/images/logo-dark.svg';
 * import logo from 'assets/images/logo.svg';
 *
 */

// ==============================|| LOGO SVG ||============================== //

const Logo = () => {
  const siteInfo = useSelector((state) => state.siteInfo);
  const theme = useTheme();
  const logo = d1hubLogo || (theme.palette.mode === 'light' ? logoLight : logoDark);

  return <img src={logo} alt={siteInfo.system_name || 'D1 Hub'} height="42" width="42" style={{ objectFit: 'contain' }} />;
};

export default Logo;
